import { t } from 'i18next';
import { useEffect, useState } from 'react';

import TickWhite from '../../../assets/img/icons/tick_2.svg';
import {
  PrimaryButton,
  SecondaryButton,
} from '../../../styledComponents/buttons';
import {
  CommonFlex,
  CommonGrid,
  CommonText,
  InputField,
} from '../../../styledComponents/common';
import {
  CheckBoxSquare,
  CheckListNameInputField,
} from '../../../styledComponents/tasks';
import AddItemModal from '../../Items/AddItemModal';
import { InfoSection } from '../officesStyles';
import ImageUpload from './ImageUploadOffice';
import PdfUpload from './PdfUploadOffice';

const ItemsRelatedToCampsSection = ({
  items,
  setItems,
  itemsList,
  numberOfPilgrims,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [initialItemList, setInitialItemList] = useState([...itemsList]);

  useEffect(() => {
    const tmpList = itemsList.map(item => ({
      ...item,
      ...items.find(i => i.id === item.id),
      quantity: item.same_as_pilgrims
        ? numberOfPilgrims
        : items.find(i => i.id === item.id)?.quantity || 0,
      selected: items.find(i => i.id === item.id)?.selected || false,
    }));
    setInitialItemList(tmpList);
  }, [itemsList]);

  useEffect(() => {
    const updatedItemList = initialItemList.map(initialItem => ({
      ...initialItem,
      quantity: initialItem.same_as_pilgrims
        ? numberOfPilgrims
        : initialItem.quantity,
    }));
    setInitialItemList(updatedItemList);
    setItems(updatedItemList.filter(item => item.selected));
  }, [numberOfPilgrims]);

  useEffect(() => {
    const updatedItemList = itemsList.map(item => ({
      ...item,
      ...items.find(i => i.id === item.id),
      quantity: item.same_as_pilgrims
        ? numberOfPilgrims
        : items.find(i => i.id === item.id)?.quantity || 0,
      selected: items.find(i => i.id === item.id)?.selected || false,
    }));
    setInitialItemList(updatedItemList);
  }, [items]);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleSelectItem = item => {
    if (item.selected) {
      return;
    }

    const updatedItemList = initialItemList?.map(initialItem => {
      if (initialItem.id === item.id) {
        return {
          ...initialItem,
          selected: !initialItem.selected,
        };
      }
      return initialItem;
    });
    setInitialItemList(updatedItemList);
    setItems(updatedItemList.filter(item => item.selected));
  };

  const handleQuantityChange = (e, id) => {
    let selected = false;
    const updatedItemList = initialItemList.map(initialItem => {
      if (initialItem.id === id) {
        selected = initialItem.selected;
        return {
          ...initialItem,
          quantity: parseInt(e.target.value, 10) || 0,
        };
      }
      return initialItem;
    });
    setInitialItemList(updatedItemList);
    if (selected) {
      setItems(updatedItemList.filter(item => item.selected));
    }
  };

  return (
    <>
      <InfoSection>
        <CommonFlex justifyContent="space-between">
          <CommonText name title fontSize="16px">
            {t('items_related_to_this_camp')}
          </CommonText>
        </CommonFlex>
        <CommonFlex gap="10px" direction="column" alignItems="start">
          {initialItemList?.map((item, index) => (
            <CommonGrid
              key={index}
              columns="1fr 1fr"
              style={{
                width: '500px',
              }}
            >
              <CommonFlex gap="5px">
                <CheckBoxSquare
                  checked={item.selected}
                  onClick={() => {
                    handleSelectItem(item);
                  }}
                  style={{ cursor: item.selected ? 'not-allowed' : 'pointer' }}
                >
                  <img src={TickWhite} alt="tick" width="16px" height="16px" />
                </CheckBoxSquare>
                <CommonText name>{item.name}</CommonText>
              </CommonFlex>
              <CommonFlex gap="5px">
                <CommonText name>{t('quantity')}:</CommonText>

                <InputField
                  type="number"
                  disabled={item.same_as_pilgrims}
                  value={item.quantity}
                  onChange={e => {
                    handleQuantityChange(e, item.id);
                  }}
                />
              </CommonFlex>
            </CommonGrid>
          ))}
        </CommonFlex>
      </InfoSection>
    </>
  );
};

export default ItemsRelatedToCampsSection;
